import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageLeon = props => {
  return <CityLandingPage cityKey="Leon" cityConfig={cityContent.leon} {...props} />;
};

export default LandingPageLeon;
